import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'

import { COPY_SCENARIO_ASYNC } from 'containers/AwarenessCenter/Scenarios/constants'
import { ADD_SCENARIO_ASYNC, SAVE_SCENARIO_ASYNC } from 'containers/ScenarioForm/constants'

import {
  autoSelectScenariosError,
  autoSelectScenariosSuccess,
  fetchCategoriesError,
  fetchCategoriesSuccess,
} from './actions'
import {
  AUTO_SELECT_SCENARIOS_ASYNC,
  CHANGE_CREATED_BY_FILTER,
  CHANGE_LEVEL_FILTER,
  CHANGE_SORT_OPTION,
  CHANGE_TYPE_FILTER,
  FETCH_CATEGORIES_ASYNC,
  PICK_CATEGORY,
  SEARCH_CHANGE,
} from './constants'
import { selectLocales } from './selectors'

const fetchCategoriesEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_CATEGORIES_ASYNC.INITIATE,
      SAVE_SCENARIO_ASYNC.SUCCESS,
      PICK_CATEGORY,
      SEARCH_CHANGE,
      CHANGE_SORT_OPTION,
      CHANGE_LEVEL_FILTER,
      CHANGE_TYPE_FILTER,
      CHANGE_CREATED_BY_FILTER,
      ADD_SCENARIO_ASYNC.SUCCESS,
      COPY_SCENARIO_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === CHANGE_SORT_OPTION && !action.payload.isFetchCategories) {
        return false
      }
      if (
        action.type === ADD_SCENARIO_ASYNC.SUCCESS ||
        action.type === SAVE_SCENARIO_ASYNC.SUCCESS
      ) {
        return window.location.pathname.indexOf(URL_CONST.awarenessCenter.wizardCampaign) !== -1
      } else return true
    })
    .mergeMap(() =>
      api.wizardCampaign
        .getScenarios(store.getState().partnerOptions.selectedCompany?.value, {
          locales: selectLocales(store.getState()),
          categoryId:
            store.getState().awarenessCenter.wizardSimulationCampaign.scenariosStep
              .pickedCategoryId,
          typeFilter:
            store.getState().awarenessCenter.wizardSimulationCampaign.scenariosStep.typeFilter,
          awarenessFilter:
            store.getState().awarenessCenter.wizardSimulationCampaign.scenariosStep.levelFilter,
          sortBy:
            store.getState().awarenessCenter.wizardSimulationCampaign.scenariosStep.sortOption,
          searchString:
            store.getState().awarenessCenter.wizardSimulationCampaign.scenariosStep.search,
          createdByFilter:
            store.getState().awarenessCenter.wizardSimulationCampaign.scenariosStep.createdByFilter,
          deliveryType:
            store.getState().awarenessCenter.wizardSimulationCampaign.self.campaign.delivery,
        })
        .mergeMap(({ response }) => Observable.of(fetchCategoriesSuccess(response)))
        .catch((error) => Observable.of(epicsErrorHandler(fetchCategoriesError, error)))
        .takeUntil(action$.ofType(FETCH_CATEGORIES_ASYNC.CANCEL))
    )

const autoSelectScenariosEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(AUTO_SELECT_SCENARIOS_ASYNC.INITIATE).mergeMap((action) =>
    api.wizardCampaign
      .autoSelectScenarios(store.getState().partnerOptions.selectedCompany?.value, {
        action: action.payload.type,
        defaultLocaleId:
          store.getState().awarenessCenter.wizardSimulationCampaign.self.campaign.defaultLocaleId,
        selectedLocaleIds:
          store.getState().awarenessCenter.wizardSimulationCampaign.self.campaign.selectedLocaleIds,
        deliveryType:
          store.getState().awarenessCenter.wizardSimulationCampaign.self.campaign.delivery,
        participantsChoices:
          store.getState().awarenessCenter.wizardSimulationCampaign.self.campaign.participants
            .included,
        participantsExcludeChoices:
          store.getState().awarenessCenter.wizardSimulationCampaign.self.campaign.participants
            .excluded,
      })
      .mergeMap(({ response }) =>
        Observable.of(autoSelectScenariosSuccess(action.payload.type, response))
      )
      .catch((error) => Observable.of(epicsErrorHandler(autoSelectScenariosError, error)))
      .takeUntil(action$.ofType(AUTO_SELECT_SCENARIOS_ASYNC.CANCEL))
  )

export default combineEpics(fetchCategoriesEpic, autoSelectScenariosEpic)
